import { useState, useEffect } from "react";
import ProcesosApi from "api/procesosApi";

export const useDeudas = (procesoId, open, disponible) => {
  const [deudasPorClase, setDeudasPorClase] = useState({});
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  // CAMBIO: Se ha eliminado `disponible` del array de dependencias.
  // El hook ahora solo se ejecutará cuando el modal se abra (`open`) o cambie el `procesoId`.
  useEffect(() => {
    const fetchDeudas = async () => {
      // Mantenemos la condición para no ejecutar si el modal no está abierto o no hay ID.
      if (!open || !procesoId) return;
      setLoading(true);
      try {
        const response = await ProcesosApi.obtenerDeudasProceso(procesoId);
        if (!response?.data?.deudas || !Array.isArray(response.data.deudas)) {
          throw new Error("No se pudieron cargar las deudas.");
        }
        // El cálculo del 'disponible' se sigue haciendo aquí, pero ya no causa un re-fetch.
        let disponibleNumerico;
        if (typeof disponible === "string") {
          disponibleNumerico = parseInt(
            disponible
              .replace(/\./g, "")
              .replace(",", ".")
              .replace(/[^\d.]/g, "")
          );
        } else if (typeof disponible === "number") {
          disponibleNumerico = Math.round(disponible);
        } else {
          disponibleNumerico = 0;
        }

        const agrupadasPorClase = response.data.deudas.reduce((acc, deuda) => {
          const clase = deuda.str_clase_deuda?.nombre || "SIN CLASE";
          if (!acc[clase]) {
            acc[clase] = {
              deudas: [],
              totalDeuda: 0,
              totalConciliado: 0,
              totalAcuerdo: 0,
              cuotaBase: disponibleNumerico,
              tasaBase: 0,
            };
          }
          acc[clase].deudas.push(deuda);
          acc[clase].totalDeuda += parseFloat(deuda.capital || 0);
          acc[clase].totalConciliado += parseFloat(deuda.capital_conciliado || 0);
          acc[clase].totalAcuerdo += parseFloat(deuda.capital_acuerdo || 0);
          return acc;
        }, {});
        setDeudasPorClase(agrupadasPorClase || {});
        setErrorMessage(null);
      } catch (error) {
        setErrorMessage(error.message || "Error al cargar las deudas");
        setDeudasPorClase({});
      } finally {
        setLoading(false);
      }
    };

    fetchDeudas();
  }, [procesoId, open]); // <-- CAMBIO CLAVE AQUÍ

  return { deudasPorClase, loading, errorMessage };
};

export default useDeudas;
